/* tslint:disable:max-line-length */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'novo',
        title: 'Inventário',
        type: 'collapsable', // Define como 'collapsable' para suportar submenu
        icon: 'heroicons_outline:chart-pie',
        link: '/example',
        children: [
            // Submenu adicionado aqui
            {
                id: 'inventario',
                title: 'Gases de Efeito Estufa',
                type: 'basic',
                link: '/inventario',
                icon: 'heroicons_outline:document-text',
            },
        ],
    },
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example',
    },
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example',
    },
];

export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id: 'novo',
        title: 'Inventários',
        type: 'collapsable', // Define como 'collapsable' para suportar submenu
        icon: 'heroicons_outline:chart-pie',
        link: '/example',
        children: [
            // Submenu adicionado aqui
            {
                id: 'inventario',
                title: 'Inventário de Gases de Efeito Estufa',
                type: 'basic',
                link: '/inventario',
                icon: 'heroicons_outline:document-text',
            },
        ],
    },
];
